module.exports = __webpack_public_path__ + "static/deveng-logo-f66be94dcf4d5c9695b09f9d2e46f16d.png";